import React from "react";
import { AgGridReact } from "ag-grid-react";
import { useMemo, useState, useCallback, useRef } from "react";

 
import { ThreeCircles } from "react-loader-spinner";

const CustomLoadingOverlay = (props) => {
    return (
      <div
        className="ag-overlay-loading-center"
        style={{ height: '9%' }}
      >
        {props.loadingMessage}
      </div>
    );
  };
  const CustomNoRowsOverlay = (props) => {
    return (
      <div
        className="ag-overlay-loading-center"
        style={{ height: '9%'}}
      >
        {/* <ThreeCircles
            height="100"
            width="100"
            color="#4fa94d"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="three-circles-rotating"
            outerCircleColor="var(--theme1_primary)"
            innerCircleColor="var(--theme1_secondary)"
            middleCircleColor="var(--theme1_tertiary)"
          /> */}
          {props.loadingMessage}
      </div>
    );
  };

/**
 * This is a default grid component for all reports. Please do not change the settings unless customization is required.
 * @param {*} props 
 * @returns 
 */
export const AutomationReportGrid = (props) => {
  const gridRef = useRef();
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.sizeColumnsToFit();
  }, []);
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      animateRows: true,
    }),
    []
  );

  const loadingOverlayComponent = useMemo(() => {
    return CustomLoadingOverlay;
  }, []);
  const loadingOverlayComponentParams = useMemo(() => {
    return {
      loadingMessage: props.loadingOverlay,
    };
  }, []);
  const noRowsOverlayComponent = useMemo(() => {
    return CustomNoRowsOverlay;
  }, []);
  const noRowsOverlayComponentParams = useMemo(() => {
    return {
    loadingMessage: props.rowOverlay,

    };
  }, []);

  return (
    <div className="ag-theme-balham" style={gridStyle}>
      <AgGridReact
        ref={gridRef}
        rowData={props.rowData}
        columnDefs={props.colDefs}
        defaultColDef={defaultColDef}
        onGridReady={props.onGridReady}
        alwaysShowHorizontalScroll={false}
        alwaysShowVerticalScroll={false}
        sideBar={"columns"}
        onFirstDataRendered={onFirstDataRendered}
        pagination={true}
        loadingOverlayComponent={loadingOverlayComponent}
        loadingOverlayComponentParams={loadingOverlayComponentParams}
        noRowsOverlayComponent={noRowsOverlayComponent}
        noRowsOverlayComponentParams={noRowsOverlayComponentParams}
      />
    </div>
  );
};

export const ReportModalGrid = (props) => {
  console.log("REPORT MODAL GRID PROPS: ", props)
  const gridRef = useRef();
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.sizeColumnsToFit();
  }, []);
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      animateRows: true,
    }),
    []
  );

  const loadingOverlayComponent = useMemo(() => {
    return CustomLoadingOverlay;
  }, []);
  const loadingOverlayComponentParams = useMemo(() => {
    return {
      loadingMessage: props.loadingOverlay,
    };
  }, []);
  const noRowsOverlayComponent = useMemo(() => {
    return CustomNoRowsOverlay;
  }, []);
  const noRowsOverlayComponentParams = useMemo(() => {
    return {
    loadingMessage: props.rowOverlay,

    };
  }, []);

  return (
    <div className="ag-theme-balham" style={gridStyle}>
      <AgGridReact
        ref={gridRef}
        rowData={props.rowData}
        columnDefs={props.colDefs}
        defaultColDef={defaultColDef}
        onGridReady={props.onGridReady}
        alwaysShowHorizontalScroll={false}
        alwaysShowVerticalScroll={false}
        sideBar={"columns"}
        onFirstDataRendered={onFirstDataRendered}
        pagination={true}
        loadingOverlayComponent={loadingOverlayComponent}
        loadingOverlayComponentParams={loadingOverlayComponentParams}
        noRowsOverlayComponent={noRowsOverlayComponent}
        noRowsOverlayComponentParams={noRowsOverlayComponentParams}
      />
    </div>
  );
};